import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b090d8ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "image-viewer__toolbar" }
const _hoisted_5 = { class: "zoom-value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toolbar-divider" }, null, -1))

import { computed, ref, watch } from 'vue'

interface Props {
  url: string
  width?: string | number
  height?: string | number
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageViewer',
  props: {
    url: null,
    width: { default: '100%' },
    height: { default: '100%' }
  },
  setup(__props: any) {

const props = __props as { url: string, width: string | number, height: string | number }



const visible = ref(false)
const zoom = ref(1)
const rotation = ref(0)

const position = ref({
  x: 0,
  y: 0
})

const isDragging = ref(false)

const dragStart = ref({
  x: 0,
  y: 0
})

const positionStart = ref({
  x: 0,
  y: 0
})

const imageStyle = computed(() => ({
  transform: `
    translate(${position.value.x}px, ${position.value.y}px)
    scale(${zoom.value})
    rotate(${rotation.value}deg)
  `
}))

function open() {
  // eslint-disable-next-line no-use-before-define
  reset()
  visible.value = true
}

function close() {
  visible.value = false
}

function zoomIn() {
  zoom.value = Math.min(
    5,
    Number((zoom.value + 0.25).toFixed(2))
  )
}

function zoomOut() {
  zoom.value = Math.max(
    0.25,
    Number((zoom.value - 0.25).toFixed(2))
  )

  if (zoom.value <= 1) {
    position.value = {
      x: 0,
      y: 0
    }
  }
}

function reset() {
  zoom.value = 1
  rotation.value = 0

  position.value = {
    x: 0,
    y: 0
  }
}

function rotateLeft() {
  rotation.value -= 90
}

function rotateRight() {
  rotation.value += 90
}

function handleWheel(event: WheelEvent) {
  event.preventDefault()

  if (event.deltaY < 0) {
    zoomIn()
  } else {
    zoomOut()
  }
}

function startDrag(event: MouseEvent) {
  if (zoom.value <= 1) return

  isDragging.value = true

  dragStart.value = {
    x: event.clientX,
    y: event.clientY
  }

  positionStart.value = {
    x: position.value.x,
    y: position.value.y
  }
}

function drag(event: MouseEvent) {
  if (!isDragging.value) return

  position.value = {
    x:
      positionStart.value.x
      + (event.clientX - dragStart.value.x),

    y:
      positionStart.value.y
      + (event.clientY - dragStart.value.y)
  }
}

function stopDrag() {
  isDragging.value = false
}

function handleDoubleClick() {
  if (zoom.value === 1) {
    zoom.value = 2
  } else {
    reset()
  }
}

function handleKeydown(event: KeyboardEvent) {
  if (!visible.value) return

  // eslint-disable-next-line default-case
  switch (event.key) {
    case 'Escape':
      close()
      break

    case '+':
    case '=':
      zoomIn()
      break

    case '-':
      zoomOut()
      break

    case 'r':
    case 'R':
      rotateRight()
      break
  }
}

function fullscreen() {
  const element = document.querySelector(
    '.image-viewer'
  ) as HTMLElement | null

  if (!element) return

  if (!document.fullscreenElement) {
    // eslint-disable-next-line no-unused-expressions
    element.requestFullscreen?.()
  } else {
    // eslint-disable-next-line no-unused-expressions
    document.exitFullscreen?.()
  }
}

watch(visible, (value) => {
  if (value) {
    window.addEventListener('keydown', handleKeydown)
  } else {
    window.removeEventListener('keydown', handleKeydown)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: __props.url,
      alt: "Preview",
      class: "image-preview",
      style: _normalizeStyle({ width: props.width, height: props.height }),
      onClick: open
    }, null, 12, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "image-viewer" }, {
        default: _withCtx(() => [
          (visible.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "image-viewer",
                onClick: _withModifiers(close, ["self"])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "viewer-button viewer-close",
                  onClick: close
                }, " ✕ "),
                _createElementVNode("div", {
                  class: "image-viewer__content",
                  onWheel: handleWheel,
                  onMousedown: startDrag,
                  onMousemove: drag,
                  onMouseup: stopDrag,
                  onMouseleave: stopDrag,
                  onDblclick: handleDoubleClick
                }, [
                  _createElementVNode("img", {
                    src: __props.url,
                    alt: "Preview",
                    class: _normalizeClass(["image-viewer__image", {
              'image-viewer__image--dragging': isDragging.value
            }]),
                    style: _normalizeStyle(_unref(imageStyle)),
                    draggable: "false"
                  }, null, 14, _hoisted_3)
                ], 32),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "viewer-button",
                    onClick: zoomOut
                  }, " − "),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(Math.round(zoom.value * 100)) + "% ", 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "viewer-button",
                    onClick: zoomIn
                  }, " + "),
                  _hoisted_6,
                  _createElementVNode("button", {
                    type: "button",
                    class: "viewer-button",
                    onClick: rotateLeft
                  }, " ↶ "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "viewer-button",
                    onClick: rotateRight
                  }, " ↷ "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "viewer-button",
                    onClick: reset
                  }, " ⟳ "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "viewer-button",
                    onClick: fullscreen
                  }, " ⛶ ")
                ])
              ], 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}
}

})